import script from "./TaggyPromo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaggyPromo.vue?vue&type=script&setup=true&lang=ts"

import "./TaggyPromo.vue?vue&type=style&index=0&id=4a4ab562&lang=css"

const __exports__ = script;

export default __exports__